export default "__VITE_ASSET__d063a841__"